import dynamic from 'next/dynamic';
import { memo } from 'react';
import { HeaderWrapper } from './styled';
import { useSelector } from 'react-redux';
import {
  selectConfigLogo,
  selectDetailProject,
  selectIsMatterportProject,
  selectThemeConfigGlobal,
} from '@containers/Home/selectors';

const Logo = dynamic(() => import('@containers/Home/components/Logo'));

const Header = memo(() => {
  const configLogo = useSelector(selectConfigLogo);
  const detailProject = useSelector(selectDetailProject);
  const themeConfig = useSelector(selectThemeConfigGlobal);
  const isMatterportProject = useSelector(selectIsMatterportProject);

  return isMatterportProject ? (
    <HeaderWrapper
      id="themeHeader"
      className={`${
        themeConfig?.selected === 'basekrpano'
          ? themeConfig.config?.positionTitle
          : ''
      }-${configLogo?.position || 'topLeft'}`}
    >
      <Logo />
      <div
        className={`--info ${
          themeConfig?.selected === 'basekrpano'
            ? themeConfig.config?.positionTitle
            : ''
        }`}
      >
        <div className="--title">{detailProject?.title}</div>
        <div className="--subtitle">{detailProject?.subTitle}</div>
      </div>
    </HeaderWrapper>
  ) : (
    <HeaderWrapper id="themeHeader">
      <Logo />
    </HeaderWrapper>
  );
});

export default Header;
